/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropmessagesend2Inputs */

const en_dropmessagesend2 = /** @type {(inputs: Dropmessagesend2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send as Pulsify`)
};

const de_dropmessagesend2 = /** @type {(inputs: Dropmessagesend2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als Pulsify senden`)
};

/**
* | output |
* | --- |
* | "Send as Pulsify" |
*
* @param {Dropmessagesend2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropmessagesend2 = /** @type {((inputs?: Dropmessagesend2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropmessagesend2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropmessagesend2(inputs)
	return de_dropmessagesend2(inputs)
});
export { dropmessagesend2 as "dropMessageSend" }